import { Content, List, Root, Trigger } from '@radix-ui/react-tabs';
import Icon from '../Icon';
import type { TabsProps } from './Tabs.types';

const Tabs = ({
  tabs,
  defaultActiveTab,
  activeTab,
  onTabSelect,
  extraClassNames,
  testId,
  id,
  stretchTabs = false,
}: TabsProps) => {
  const handleTabSelect = (tabId: string) => {
    if (activeTab === tabId) return;
    onTabSelect && onTabSelect(tabId);
  };

  return (
    <Root
      className={`tw:flex tw:flex-col tw:min-w-75 tw:max-w-full tw:flex-grow tw:focus-visible:outline-none ${
        extraClassNames || ''
      }`}
      defaultValue={defaultActiveTab}
      data-testid={testId}
      id={id}
      value={activeTab}
      onValueChange={handleTabSelect}>
      <List className="tw:flex tw:flex-row tw:flex-wrap tw:z-[1001]">
        {tabs.map(
          (
            { id, icon, label, tabExtraClassNames, testId: tabsTestId, disabled, tabLabelExtraClassNames = '' },
            index,
          ) => (
            <Trigger
              className={`tw:bg-sq-white tw:dark:bg-sq-dark-background tw:h-sq-25 tw:focus-visible:outline-none tw:min-w-25 tw:px-4 tw:border-solid tw:flex tw:flex-1 tw:justify-center tw:items-center tw:border-r-[2px] tw:last:border-r-0 tw:border-sq-overlay tw:dark:border-gray-700 ${
                stretchTabs ? '' : 'tw:max-w-max tw:min-w-fit'
              } ${tabExtraClassNames || ''} ${
                activeTab === id
                  ? 'tw:border-b-sq-theme-darker tw:dark:border-b-sq-theme-darker tw:border-b-[0.1875rem]'
                  : 'tw:hover:bg-sq-light-gray tw:border-b-[0.0625rem] tw:hover:dark:bg-gray-700'
              }`}
              data-testid={tabsTestId}
              disabled={disabled}
              key={`${label}-${id}-${index}`}
              value={id}>
              <span className="tw:flex tw:items-center tw:overflow-hidden">
                {icon && (
                  <Icon
                    icon={icon}
                    testId={`${id}_tab-icon`}
                    extraClassNames="tw:text-sq-15 tw:mr-sq-7 tw:flex-shrink-0"
                  />
                )}
                <span
                  className={`tw:text-sq-13 tw:font-medium tw:whitespace-nowrap tw:overflow-hidden tw:text-ellipsis ${
                    activeTab === id
                      ? 'tw:dark:text-sq-dark-text tw:text-gray-500'
                      : 'tw:dark:text-sq-theme-darker tw:text-sq-theme-dark'
                  } ${tabLabelExtraClassNames}`}>
                  {label}
                </span>
              </span>
            </Trigger>
          ),
        )}
      </List>
      {tabs.map((tab, index) => (
        <Content
          className={`tw:bg-sq-white tw:dark:bg-sq-dark-background tw:overflow-y-auto tw:-mt-sq-1 tw:border-t-[0.0625rem] tw:border-t-sq-overlay tw:dark:border-t-gray-700 tw:z-[500] tw:flex tw:flex-col tw:flex-grow tw:focus-visible:outline-none ${
            tab.tabContentExtraClassNames || ''
          }`}
          key={`${tab.label}_${index}_content`}
          value={tab.id}>
          {tab.content}
        </Content>
      ))}
    </Root>
  );
};

export default Tabs;
